import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export const isAutomaticBreak = (isWorkable: boolean, automaticClockIn: boolean) => {
  return !isWorkable && automaticClockIn
}

export const clockIn = (clockInStr: string, date: string) => {
  const clockInTime = stringToDate(clockInStr, 'backend_datetime')

  return moment(`${date} ${clockInTime.utc().format('HH:mm:ss')}`, 'YYYY/MM/D HH:mm:ss')
}
